import React from 'react';
import RemoteDesktopSection from './RemoteDesktopSection';
import ProvisioningScriptSection from './ProvisioningScriptSection';
import AutoUpdateCheckbox from './AutoUpdateCheckbox';
import GlobalProvisionScriptsPreview from './GlobalProvisionScriptsPreview';
import ClusterApplicationsSection from './ClusterApplicationsSection';
import ClusterShutdownSection from './ClusterShutdownSection';
import { providerSupportsTimer } from '../../util/provider';
import { columnContainerStyle, columnStyle } from './formLayoutStyles';

/**
 * The standard advanced-mode sections shared across all provider forms:
 * Remote Desktop + Provisioning Script (two columns), AutoUpdate,
 * Global Provision Scripts, Cluster Applications.
 */
export default function AdvancedSectionsBlock({ form, setForm, setField, provider, advanced, marketplace, disableInputs }) {
    // macOS commissioned machines are SSH/compute only (LLM server setups) with
    // no graphical remote desktop - VNC is unusable on the headless Apple
    // Silicon Macs clients run - so hide the Remote Desktop panel for macOS.
    const isMacOS = /^macos/i.test(form.osType || '');
    return (
        <>
            {advanced && (
                <div style={columnContainerStyle}>
                    {!isMacOS && (
                        <div style={columnStyle}>
                            <RemoteDesktopSection form={form} setField={setField} provider={provider} fillHeight />
                        </div>
                    )}
                    {!marketplace.hideProvisionScript && (
                        <div style={columnStyle}>
                            <ProvisioningScriptSection
                                form={form} setField={setField} provider={provider} fillHeight
                                disabled={disableInputs}
                            />
                        </div>
                    )}
                </div>
            )}

            {advanced && <AutoUpdateCheckbox form={form} setForm={setForm} />}

            {/* Automatic shutdown: the fixed-lifetime timer and the idle rule,
                in one card because they answer the same question. Not offered
                for ACM/MaaS - those are on-prem bare-metal machines from a
                pool, with no provider meter to stop, so switching one off
                because it is quiet buys nothing. */}
            {advanced && providerSupportsTimer(provider) && (
                <ClusterShutdownSection
                    form={form} setField={setField} provider={provider}
                    disabled={disableInputs}
                />
            )}

            {(advanced || marketplace.disableGlobalScripts) && (
                <div style={marketplace.disableGlobalScripts ? { display: 'none' } : undefined}>
                    <GlobalProvisionScriptsPreview
                        provider={provider} osType={form.osType || ''} clusterName={form.hostname || ''}
                        clusterId={form.id} excludedScripts={form.excludedGlobalScripts || []}
                        onExcludedScriptsChange={(scripts) => setField('excludedGlobalScripts', scripts)}
                        disabled={disableInputs || marketplace.disableGlobalScripts}
                    />
                </div>
            )}

            {(advanced || (form.applications?.length > 0)) && (
                <ClusterApplicationsSection
                    applications={form.applications || []}
                    onChange={(apps) => setField('applications', apps)}
                    disabled={disableInputs}
                />
            )}
        </>
    );
}
